import { getMessages } from '../../../../../../store/constants';

export const BOARD_SECTION_ARCHIVE_ON_DELETE_SECTION = getMessages().getText('board_settings.archive_on_delete.title');
export const BOARD_SECTION_ARCHIVE_ON_DELETE_BUTTON = getMessages().getText('board_settings.archive_on_delete.button');
